import React, { useEffect, useRef } from "react";
import MiniGamePageHome from "./components/MiniGame/Home";
import ModalLogin from "../component/ModalLogin";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { curStateAccount, curStateMiniGame } from "../Redux/selector";
import {
  setDataPopupError,
  setOpenPopupGivePieceSuccess,
  setOpenPopupLogin,
  setPopupMission,
} from "../Redux/futures/mini-game/action";
import PopupEarnMore from "./components/MiniGame/components/PopupFooter/PopupEarnMore";
import styled, { keyframes } from "styled-components";
import PopupCongPiece from "./components/MiniGame/components/PopupFooter/PopupCongPiece";
import PopupCongratula from "./components/MiniGame/components/PopupFooter/PopupCongratula";
import { useLocation, useParams } from "react-router";
import {
  ID_TAB_MINI_GAME,
  INVITE_MARQUEE_END_DATE,
  INVITE_MARQUEE_START_DATE,
  TYPE_GIVE_PIECE_SUCCESS,
  useNewYear2025Theme,
} from "../helper/const";
import MiniGameCollectPiece from "./components/MiniGame/CollectPiece";
import MiniGamePrizeCollection from "./components/MiniGame/PrizeCollection";
import MiniGameBuyMoreCoin from "./components/MiniGame/BuyMoreCoin";
import PopupGivePiece from "./components/MiniGame/components/PopupFooter/PopupGivePiece";
import ModalNotifycation from "../component/ModalNotifycation";
import { useTranslation } from "react-i18next";
import PopupCongGivePiece from "./components/MiniGame/components/PopupFooter/PopupCongGivePiece";
import PopupMission from "./components/MiniGame/components/PopupFooter/PopupMission";
import {
  getDailyLoginMiniGamePopup,
  getItemCookie,
  setDailyLoginMiniGamePopup,
} from "../utils/cookie";
import InviteUser from "./components/MiniGame/InviteUser";
import GivePiece from "./components/MiniGame/GivePiece";
import RequestPiece from "./components/MiniGame/RequestPiece";
import moment from "moment";
import { useMediaQuery } from "../utils/hooks";
import InviteMarquee from "./components/MiniGame/components/InviteMarquee";
import Snowfall from "react-snowfall";
import { hasAuthCookie } from '@/utils/auth';
import { getCurrentUser } from '@/Redux/futures/account/actions';

export default function MiniGame({ children }) {
  const dataMiniGame = useSelector(curStateMiniGame);
  const selectorAccount = useSelector(curStateAccount);
  const dataMissionMini = dataMiniGame.dataMissionMini || [];
  const [showInviteMarquee, setShowInviteMarquee] = React.useState(false);
  const isMobile = useMediaQuery("(max-width: 576px)");
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();
  const dispatch = useDispatch();
  const { id } = useParams();
  const location = useLocation();
  const { t } = useTranslation();

  const handleActionPopupLogin = (data = false) => {
    dispatch(setOpenPopupLogin(data));
  };

  const handleClosePopupError = () => {
    dispatch(
      setDataPopupError({
        isOpen: false,
        message: "",
      })
    );
  };

  useEffect(() => {
    const checkAndUpdateMarquee = () => {
      const now = moment();
      const shouldShow = now.isBetween(
        INVITE_MARQUEE_START_DATE,
        INVITE_MARQUEE_END_DATE
      );
      setShowInviteMarquee(shouldShow);
    };

    checkAndUpdateMarquee();

    const interval = setInterval(checkAndUpdateMarquee, 30000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const isLoggedIn = hasAuthCookie() || Boolean(selectorAccount.token) || Boolean(selectorAccount.userInfo);
    if (!isLoggedIn) return;
    dispatch(getCurrentUser({}));
  }, []);

  useEffect(() => {
    const TYPE_SHOW_POPUP_INVITE = 1;
    if (
      selectorAccount.userInfo?.invite_popup &&
      selectorAccount.userInfo?.invite_popup.is_show_popup ===
      TYPE_SHOW_POPUP_INVITE
      //   &&
      // +getItemCookie("invite_popup") !== 1 // Check if the popup has not been shown before
    ) {
      dispatch(
        setOpenPopupGivePieceSuccess({
          isShow: true,
          type: TYPE_GIVE_PIECE_SUCCESS.referral_successful,
          data: {
            message: selectorAccount.userInfo?.invite_popup.message,
            super_coin_add:
              selectorAccount.userInfo?.invite_popup.super_coin_add,
            user_referred: selectorAccount.userInfo?.invite_popup.user_referred,
          },
        })
      );
    }
    //     const selectorAccount.userInfo?.received_success_popup = {
    //     "is_show_popup": 1,
    //     "give_piece_left": "89",
    //     "message": "Player 59595959 က သင့်ကို 1 Redmi Watch 5 Active update - Piece (D) ပေးထားပါသည်။ Puzzle Piece စုဆောင်းမှုကို စစ်ဆေးပါ"
    // }
    if (selectorAccount.userInfo?.received_success_popup?.is_show_popup) {
      dispatch(
        setOpenPopupGivePieceSuccess({
          isShow: true,
          type: TYPE_GIVE_PIECE_SUCCESS.receivePiece,
          data: selectorAccount.userInfo?.received_success_popup,
        })
      );
    }
    if (selectorAccount.userInfo?.give_success_popup?.is_show_popup) {
      dispatch(
        setOpenPopupGivePieceSuccess({
          isShow: true,
          type: TYPE_GIVE_PIECE_SUCCESS.requestPiece,
          data: selectorAccount.userInfo?.give_success_popup,
        })
      );
    }
  }, [
    selectorAccount.userInfo?.invite_popup,
    selectorAccount.userInfo?.received_success_popup,
    selectorAccount.userInfo?.give_success_popup,
  ]);

  useEffect(() => {
    // Check if the user has completed the daily login mini-game
    if (
      // selectorAccount.userInfo &&
      !getDailyLoginMiniGamePopup() &&
      dataMissionMini[0]?.completed
    ) {
      dispatch(
        setPopupMission({
          isShow: true,
          coin: dataMissionMini[0]?.normal_coin,
          missionName: dataMissionMini[0]?.name,
        })
      );

      // Set the cookie to prevent showing the popup again
      setDailyLoginMiniGamePopup();
    }
  }, [selectorAccount.userInfo, dataMissionMini]);

  const handleGetTab = () => {
    const { pathname = "" } = location || {};
    if (pathname.includes("/invite-user/")) {
      return <InviteUser />;
    }

    if (pathname.includes("/give/")) {
      return <GivePiece />;
    }

    if (pathname.includes("/request/")) {
      return <RequestPiece />;
    }

    switch (id) {
      case ID_TAB_MINI_GAME.home:
        return <MiniGamePageHome />;
      // case
      // case ID_TAB_MINI_GAME.takePrize:
      //   return <TakePrize />;
      // case ID_TAB_MINI_GAME.collectPiece:
      //   return <MiniGameCollectPiece />;
      // case ID_TAB_MINI_GAME.pieceCollection:
      //   return <PieceCollection />
      case ID_TAB_MINI_GAME.prizeCollection:
        return <MiniGamePrizeCollection />;
      case ID_TAB_MINI_GAME.buyMoreCoin:
        return <MiniGameBuyMoreCoin />;
      default:
        return null;
    }
  };
  // if (!dataMiniGame?.configMiniGame?.is_show) {
  //   return;
  // }
  return (
    <Container className=''>
      {IS_EVENT_NEW_YEAR_2025_THEME && (
        <SnowfallContainer>
          <Snowfall
            snowflakeCount={isMobile ? 300 : 1000}
            radius={[0.5, 3.0]}
            speed={[0.5, 1]}
            wind={[-0.5, 1]}
          />
        </SnowfallContainer>
      )}
      {/* {dataMiniGame.isShowPopupLogin ? ( //login cũ
        <ModalLogin
          open={dataMiniGame.isShowPopupLogin}
          setOpenModalLogin={handleActionPopupLogin}
          isGetContainer={false}
        />
      ) : null} */}

      {dataMiniGame.popupMission?.isShow ? (
        <PopupMission data={dataMiniGame.popupMission} />
      ) : null}

      {dataMiniGame?.dataPopupErrorMini?.isOpen ? (
        <ModalNotifycation
          open={true}
          handleCancel={handleClosePopupError}
          title={t("error")}
          message={
            dataMiniGame?.dataPopupErrorMini?.message ||
            t("mini_game.something_went_wrong")
          }
          isContainer
        />
      ) : null}

      {dataMiniGame.popupGivePiece.isShow ? (
        <PopupGivePiece type={dataMiniGame.popupGivePiece.type} />
      ) : null}

      {dataMiniGame.popupGivePieceSuccess.isShow && (
        <PopupCongGivePiece
          type={dataMiniGame.popupGivePieceSuccess.type}
          data={dataMiniGame.popupGivePieceSuccess?.data}
        />
      )}
      {/* <PopupGivePiece isShowPopupIntro={true} /> */}

      {dataMiniGame?.popupEarnMore?.isShowPopup ? <PopupEarnMore /> : null}

      {dataMiniGame.popupPiece.isShowPopupPiece ? (
        <PopupCongPiece
          type={dataMiniGame.popupPiece.type}
          data={dataMiniGame.popupPiece.data}
        />
      ) : null}

      {/* {true ? (
        <PopupCongPiece
          type={4}
          // data={dataMiniGame.popupPiece.data}
        />
      ) : null} */}

      {dataMiniGame.popupChangeCoinsSuccess.isShowPopupChangeCoinsSuccess ? (
        <PopupCongratula
          isOpen={
            dataMiniGame.popupChangeCoinsSuccess.isShowPopupChangeCoinsSuccess
          }
        />
      ) : null}

      {children ? children : handleGetTab()}

      {showInviteMarquee && <InviteMarquee></InviteMarquee>}
    </Container>
  );
}

const Container = styled.div`
  position: relative;
`;

const SnowfallContainer = styled.div`
  height: 100%;
  width: 100%;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
  z-index: 1;
`;
